module.exports = __webpack_public_path__ + "static/media/027.6e590410.jpg";